/* ==========================================================================
   OTP+ login window tweaks (loaded with the app embed styles).
   - Theme drawers/modals are native <dialog>s in the top layer: close them when the
     app window opens (e.g. "Sign in" tapped from the mobile menu), or it would sit behind.
   - The app writes its button arrows as text ("→"); in Arabic (RTL) forward points left.
   Only the app's own containers are observed.
   ========================================================================== */
(() => {
  const rtl = document.documentElement.dir === 'rtl';
  const IDS = ['otp-nca-account-modal', 'otp-cart-gate'];
  const SELECTOR = 'button, a, .otp-btn, .otp-gate-button, .otp-account-btn';

  const closeThemeOverlays = () => {
    document.querySelectorAll('dialog[open]').forEach((dialog) => {
      const overlay = dialog.closest('x-drawer, x-modal');
      if (overlay?.close) overlay.close();
      else dialog.close();
    });
  };

  const flip = (root) => {
    if (!rtl) return;
    root.querySelectorAll(SELECTOR).forEach((element) => {
      const walker = document.createTreeWalker(element, NodeFilter.SHOW_TEXT);
      while (walker.nextNode()) {
        const node = walker.currentNode;
        if (node.nodeValue.includes('→')) node.nodeValue = node.nodeValue.replace(/→/g, '←');
      }
    });
  };

  const watch = (root) => {
    if (!root || root.dataset.xhWatched) return;
    root.dataset.xhWatched = 'true';
    flip(root);
    let wasOpen = false;
    new MutationObserver(() => {
      flip(root);
      const open = root.childElementCount > 0;
      if (open && !wasOpen) closeThemeOverlays();
      wasOpen = open;
    }).observe(root, { childList: true, subtree: true, characterData: true });
  };

  const attach = () => IDS.forEach((id) => watch(document.getElementById(id)));
  attach();
  // The app adds its containers after load; look for them a few times, then stop
  let tries = 0;
  const timer = setInterval(() => {
    attach();
    if (++tries > 20 || IDS.every((id) => document.getElementById(id)?.dataset.xhWatched)) clearInterval(timer);
  }, 500);
})();
